import React from "react";
import { useField } from "formik";
import { TextField, Box, Typography } from "@mui/material";

interface Props {
  placeholder: string;
  name: string;
  label?: string;
  type?: string;
  value?: string;
  onChange?: any;
  required?: boolean;
  readOnly?: boolean;
}

export default function CustomTextInput(props: Props) {
  const [field, meta] = useField(props.name);
  const showError = !!(meta.touched && meta.error);

  return (
    <Box sx={{ mb: 2 }}>
      <TextField
        {...field}
        {...props}
        name={field.name}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value ?? ""}
        error={showError}
        fullWidth
        variant="standard"
        InputProps={{
          readOnly: props.readOnly,
        }}
      />
      {showError && (
        <Typography color="error" variant="caption">
          {meta.error}
        </Typography>
      )}
    </Box>
  );
}
